import Text, { TextProps } from './Text'

const fontVariant = 'tabular-nums'

const TextNumber: FC<TextProps> = (props) => {
  return <Text {...props} $fontVariantNumeric={fontVariant} />
}

export default TextNumber
